import type {MessageState} from '@assistant-ui/core'
import {getExternalStoreMessages} from '@assistant-ui/react'

import type {Message} from './hooks'

/**
 * Omics `Message` rows bound by assistant-ui's ExternalStoreAdapter (`bindExternalStoreMessage`).
 * Centralizes churn if assistant-ui renames or replaces `getExternalStoreMessages`.
 */
export function getOmicsAssistantMessage(threadMessage: MessageState): Message | undefined {
  const bound = getExternalStoreMessages<Message>(threadMessage)
  for (const m of bound) {
    if (m.type === 'bot' || m.type === 'agent-response') return m
  }
  return undefined
}

/** The Omics user row behind an assistant-ui user message. */
export function getOmicsUserMessage(threadMessage: MessageState): Message | undefined {
  return getExternalStoreMessages<Message>(threadMessage).find((m) => m.type === 'user')
}
